import { SupabaseClient } from "@supabase/supabase-js";
import { getUser } from "../supabase/supabase";
import { logException } from "@punchup/sentry";

export async function getFollowedVenueIds(
  supabase: SupabaseClient
): Promise<string[]> {
  const user = await getUser(supabase);
  if (!user) {
    return [];
  }
  try {
    const { data } = await supabase
      .from("user_venue_follows")
      .select("*")
      .eq("user_id", user.id)
      .throwOnError();
    return data?.map((row) => row.venue_page_id) ?? [];
  } catch (error) {
    logException(error);
  }
  return [];
}
